import React from 'react';

import { ITableModel } from '../interface';
import { IQuotes, QuoteStatusTypes } from 'models/Quote';
import Text from 'components/Text';

const TextQtdItens = ({ items }: any) => {
  return (
    <Text className="color-blue-gray" size={12}>
      {items?.length || '-'}
    </Text>
  );
};

const quoteModelComplete: Array<ITableModel> = [
  { label: 'Código Mafra', key: 'code', size: 90, maxSize: 90 },
  {
    label: 'Código Externo',
    key: 'externalOrderCode',
    size: 120,
    maxSize: 120,
  },
  {
    label: 'Criado em',
    key: 'quotationDate',
    type: 'date',
    size: 110,
    maxSize: 110,
  },
  { label: 'Cliente', size: 180, key: 'company.companyName', noFilter: true },
  { label: 'Origem', key: 'quotationOrigin', size: 100, maxSize: 100 },
  {
    label: 'Qtd itens',
    key: 'itemsQuatity',
    noFilter: true,
    size: 60,
    maxSize: 60,
    Component: ({ items }) => (
      <TextQtdItens items={items} />
    ),
  },

  { label: 'Valor', key: 'price', type: 'currency', size: 140, maxSize: 140 },
  {
    label: 'Prazo de envio',
    key: 'timeShipping',
    type: 'date',
    size: 160,
    maxSize: 160,
  },
  {
    label: 'Status',
    key: 'status',
    size: 200,
    maxSize: 200,
    Component: (data: IQuotes) => (
      <Text className="color-blue-gray">{QuoteStatusTypes[data.status]}</Text>
    ),
  },
];

const quoteModelPanelComplete: Array<ITableModel> = [
  {
    label: 'Data de Criação',
    key: 'quotationDate',
    type: 'date',
    size: 110,
    maxSize: 110,
  },
  { label: 'Origem', key: 'quotationOrigin', size: 100, maxSize: 100 },
  { label: 'Razão Social', size: 200, key: 'company.companyName' },

  {
    label: 'Qtd itens',
    key: 'itemsQuatity',
    noFilter: true,
    size: 60,
    maxSize: 60,
    Component: ({ items }) => (
      <TextQtdItens items={items} />
    ),
  },

  {
    label: 'Expira em',
    key: '',
    type: '',
    size: 120,
    maxSize: 120
  },
  {
    label: 'Status',
    key: 'status',
    size: 200,
    maxSize: 200,
    Component: (data: IQuotes) => (
      <Text className="color-blue-gray">{QuoteStatusTypes[data.status]}</Text>
    ),
  },
];

const quotesModelWithoutDePara: Array<ITableModel> = [
  { label: 'Cotação', key: 'code', size: 90, maxSize: 90 },
  { label: 'Descrição', key: '', type: '', size: 110, maxSize: 110 },
  { label: 'Marca', key: '', size: 100, maxSize: 100 },
  { label: 'Fabricante', size: 200, key: 'company.companyName' },
];

let quotesModelDash: Array<ITableModel> = [];
quotesModelDash = [
  { label: 'Código Mafra', key: 'code', size: 90, maxSize: 90 },
  {
    label: 'Código Externo',
    key: 'externalOrderCode',
    size: 120,
    maxSize: 120,
  },
  {
    label: 'Criado em',
    key: 'quotationDate',
    type: 'date',
    size: 130,
    maxSize: 130,
  },
  { label: 'Qtd Itens', key: 'itemsQuatity', size: 70, maxSize: 70 },
  { label: 'Valor', key: 'price', type: 'currency', size: 110, maxSize: 110 },
  {
    label: 'Status',
    key: 'status',
    Component: (data: IQuotes) => (
      <Text className="color-blue-gray" size={12}>
        {QuoteStatusTypes[data.status]}
      </Text>
    ),
  },
];

export {
  quoteModelComplete,
  quoteModelPanelComplete,
  quotesModelWithoutDePara,
  quotesModelDash,
};
